import styles from './DiscountCard.module.scss'
import { DiscountCardProps } from './DiscountCard.types'
import { Badge, BadgeVariant, IconRegistry, Typography } from '@percent/lemonade'
import { getFormattedDate } from '@percent/cause-dashboard/common/utility/date'

type StatusDetails = {
  variant: BadgeVariant
  icon?: keyof typeof IconRegistry
  text: string
}

export const statusMap: Record<string, StatusDetails> = {
  PENDING: {
    variant: 'warning',
    icon: 'clock',
    text: 'Pending verification'
  },
  APPROVED: {
    variant: 'positive',
    icon: 'check-badge',
    text: 'Approved'
  },
  REJECTED: {
    variant: 'critical',
    icon: 'reject',
    text: 'Rejected'
  },
  undefined: {
    variant: 'default',
    text: 'Unknown status'
  }
}

export function DiscountCard({
  validation: { submittedAt, status, partnerId, configurationId },
  application: { logo, displayName }
}: Readonly<DiscountCardProps>) {
  return (
    <div className={styles.discountCardContainer}>
      <div className={styles.cardDetails}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt={displayName} className={styles.image} />
        </div>
        <Typography variant="h4" color="secondary" className={styles.tileName}>
          {displayName}
        </Typography>
        <Typography data-testid="tile-description" $color="gray400" className={styles.tileDate}>
          {getFormattedDate(submittedAt)}
        </Typography>
      </div>
      <div className={styles.status}>
        <Badge
          variant={statusMap[status].variant}
          icon={statusMap[status].icon}
          testId={`discount-card-status-${partnerId}-${configurationId}`}
        >
          {statusMap[status].text}
        </Badge>
      </div>
    </div>
  )
}
